/**
 * An ISO timestamp as a short wall-clock time in the reader's zone, spelled the
 * way the UI language spells it ("20:32" in French, "8:32 PM" in English).
 *
 * Empty or unparseable input returns '' so callers drop the time rather than
 * print a value nobody can read.
 */
export function formatShortTime(
  iso: string | null | undefined,
  locale: string | undefined
): string {
  if (!iso) return '';

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat(locale, { timeStyle: 'short' }).format(date);
}
